import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import axios from 'axios';
import Header from '../Appointment/components/Header/Header';
import SearchBar from '../../components/SearchBar/SearchBar';
import TableList from './components/TableList/TableList';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        padding: 8,
        
    },

    results: {
        marginTop: 8
    }
    
}));

export default function AppointmentDemo() {

    const classes = useStyles();

    const handleFilter = () => { };
    const handleSearch = () => { };

    return (
        <React.Fragment className={classes.root}>
            <Grid container>
                <Grid item xs={12} >
                    <div
                        // className={classes.root}
                        classes={classes}
                        title="Appointment Details"
                    >
                        {/* <SearchBar
                    onSearch={handleSearch}
                /> */}
                        <TableList
                            classes={classes}
                            className={classes.results}
                        />
                    </div>
                </Grid>
            </Grid>
            
        </React.Fragment>
           
            
        
            

    )
}